module.exports = __webpack_public_path__ + "img/comp_round-hs.c6da2bb6.png";